import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-work-shift-selector',
  templateUrl: './work-shift-selector.component.html',
  styleUrls: ['./work-shift-selector.component.scss']
})
export class WorkShiftSelectorComponent {
  
  @Input() selectedShift;
  @Input() label = this.translateService.instant('reports.shift');
  @Output() selectedShiftChange = new EventEmitter<number>();

  shifts = [
    { value: null, label: this.translateService.instant('reports.none') },
    { value: 6, label: "06:00, 14:00, 22:00" },
    { value: 7, label: "07:00, 15:00, 23:00" },
    { value: 8, label: "08:00, 16:00, 00:00" },
    { value: 9, label: "09:00, 17:00, 01:00" },
    { value: 10, label: "10:00, 18:00, 02:00" },
    { value: 11, label: "11:00, 19:00, 03:00" },
    { value: 4, label: "04:00, 12:00, 20:00" },
    { value: 5, label: "05:00, 13:00, 21:00" }
  ];

  constructor(private translateService: TranslateService) { }

  onShiftChange() {
    this.selectedShiftChange.emit(this.selectedShift);
  }
}
